import { WmsInstance } from "@/instance/axios";
import { StockPlansGet200Response } from "@sizlcorp/sizl-api-document/dist/models";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export type StockPlansOption = {
  value: string;
  label: string;
  quantity?: string;
  // group?: string;
};
const getAutoCompleteKeyword = (
  keyword: string,
  partnerCode: string,
  purchaseOrderItemId: number,
) =>
  WmsInstance.stockPlansGet(
    {
      search: keyword,
      searchFields: ["code", "itemCode"],
      populate: [
        "transportation",
        "partner",
        "location",
        "itemName",
        "lot",
        "user",
        "purchaseOrderItem",
        "quantities",
      ],
    },
    {
      params: {
        query: {
          ...(partnerCode && { partnerCode }),
          ...(purchaseOrderItemId && { purchaseOrderItemId }),
        },
      },
    },
  );

export const useStockPlansAutoComplete = (
  focus = false,
  keyword = "",
  partnerCode: string = "",
  purchaseOrderItemId: number,
  options?: {
    onSuccess: (data: StockPlansOption[]) => void;
  },
) => {
  return useQuery(
    ["transportation-get-autocomplete-keyword", keyword],
    () => getAutoCompleteKeyword(keyword, partnerCode, purchaseOrderItemId ?? 0),
    {
      enabled: focus,
      select: (data: AxiosResponse<StockPlansGet200Response, any>): StockPlansOption[] =>
        data?.data?.rows?.map((stockPlan) => {
          return {
            value: stockPlan.id?.toString() ?? "",
            label: `코드 : ${stockPlan?.code}, 품목명 : ${stockPlan?.itemName}, 로트 : ${stockPlan?.lotData?.name ?? "-"}`,
            quantity: Number(stockPlan?.availableActualQuantity).toString(),
          };
        }) ?? [],
      onSuccess: options?.onSuccess,
    },
  );
};

const getTransportationByCode = (code: string | null) =>
  WmsInstance.stockPlansGet({
    ...(code && { search: code }),
    searchFields: ["code"],
  });

export const useTransportationCode = (
  enabled: boolean = false,
  code: string | null,
  options?: {
    onSuccess: (data?: StockPlansOption[]) => void;
  },
) => {
  return useQuery(["transportation-get-code", code], () => getTransportationByCode(code), {
    enabled,
    select: (data: AxiosResponse<StockPlansGet200Response, any>) =>
      data?.data?.rows?.map((stockPlan) => {
        return {
          value: stockPlan?.id?.toString() ?? "",
          label: stockPlan?.code as string,
        };
      }),
    onSuccess: options?.onSuccess,
  });
};
